import startcase from 'lodash.startcase';
import { DateTime } from 'luxon';
import SkeletonCard from '../cards/SkeletonCard';
import EventWebinarFormattedTime from '../cards/EventWebinarCard/EventWebinarFormattedTime';
import { useLocalization } from '../../custom-hooks/useLocalization';

const SkeletonCards = () => Array.from(Array(12), (_, i) => <SkeletonCard key={i} />);

const SearchListView = ({ isLoading, results, insightReadMoreText, timeZone }) => {
  const { resourceStrings } = useLocalization();

  const formatTime = (isoDate) =>
    DateTime.fromISO(isoDate, { setZone: true, zone: timeZone }).toFormat('t');

  const eventTypes = {
    0: resourceStrings['bdO.EventsWebinars.Event'],
    1: resourceStrings['bdO.EventsWebinars.Webinar'],
    2: resourceStrings['bdO.EventsWebinars.PastWebinar'],
    default: resourceStrings['bdO.EventsWebinars.Event']
  };

  const getEventCtaText = (event) => {
    if (event.eventtype.toString() === '2') {
      return resourceStrings['bdO.EventsWebinars.ViewRecording'];
    }
    return insightReadMoreText;
  };

  return (
    <div className="list-view">
      {isLoading ? (
        <SkeletonCards />
      ) : (
        results.map((result) => {
          if (result.classname === 'bdo.insightnode') {
            return (
              <div className="list-item" key={result.nodeguid}>
                <div className="list-content">
                  {result.primarycategory && (
                    <span className={`tag`}>{startcase(result.primarycategory)}</span>
                  )}
                  <h2>{result.pagetitle}</h2>
                  <p className="description">{result.description}</p>
                  <time
                    className="search-page-date"
                    dateTime={result.sys_created}
                    suppressHydrationWarning
                  >
                    <EventWebinarFormattedTime
                      isMonthFirst={true}
                      fullMonth={true}
                      isoDate={result.sys_created}
                      timeZone={timeZone}
                    />
                  </time>
                </div>
                <ButtonLink
                  text={insightReadMoreText}
                  type="tertiary"
                  tertiaryIconHasBackground={false}
                  useWidgetIdWrapper={false}
                  link={result.url}
                />
              </div>
            );
          }
          if (result.classname === 'bdo.eventwebinarnode') {
            return (
              <div className="list-item" key={result.nodeguid}>
                <div className="list-content">
                  {result.eventtype !== null && (
                    <span className="tag">{eventTypes[result.eventtype]}</span>
                  )}
                  <h2>{result.pagetitle}</h2>
                  <p className="description">{result.description}</p>
                  <div className="event-info">
                    <time
                      className="search-page-date"
                      dateTime={result.startdatetime}
                      suppressHydrationWarning
                    >
                      <EventWebinarFormattedTime
                        isMonthFirst={true}
                        fullMonth={true}
                        isoDate={result.startdatetime}
                      />
                    </time>
                    <time dateTime={formatTime(result.startdatetime)} suppressHydrationWarning>
                      {formatTime(result.startdatetime)} {result.timezone}
                    </time>
                    {result.city && result.eventState && (
                      <>
                        &nbsp;|&nbsp;
                        <address>
                          <span>
                            {result.city}, {result.eventState}
                          </span>
                        </address>
                      </>
                    )}
                  </div>
                </div>
                <ButtonLink
                  text={getEventCtaText(result)}
                  type="tertiary"
                  tertiaryIconHasBackground={false}
                  useWidgetIdWrapper={false}
                  link={result.url}
                />
              </div>
            );
          }

          return (
            <div className="list-item" key={result.nodeguid}>
              <div className="list-content">
                {result.primarycategory && (
                  <span className={`tag`}>{startcase(result.primarycategory)}</span>
                )}
                <h2>{result.pagetitle}</h2>
                <p className="description">{result.description}</p>
              </div>
              <ButtonLink
                text={insightReadMoreText}
                type="tertiary"
                tertiaryIconHasBackground={false}
                useWidgetIdWrapper={false}
                link={result.url}
              />
            </div>
          );
        })
      )}
    </div>
  );
};

export default SearchListView;
